import React from "react";

interface IconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const IssueNotFoundInMobile: React.FC<IconProps> = ({
  width = 218,
  height = 223,
  className = ""
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 218 223"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M109 218C169.199 218 218 169.199 218 109C218 48.801 169.199 0 109 0C48.801 0 0 48.801 0 109C0 169.199 48.801 218 109 218Z"
      fill="url(#paint0_linear_539_1038)"
    />
    <g filter="url(#filter0_d_539_1038)">
      <mask
        id="mask0_539_1038"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={218}
        height={218}
      >
        <path
          d="M109 218C169.199 218 218 169.199 218 109C218 48.801 169.199 0 109 0C48.801 0 0 48.801 0 109C0 169.199 48.801 218 109 218Z"
          fill="url(#paint1_linear_539_1038)"
        />
      </mask>
      <g mask="url(#mask0_539_1038)">
        <path
          d="M56.1455 44.2002H161.854C165.099 44.2004 167.8 47.4936 167.8 51.6523V212.348C167.8 216.506 165.099 219.8 161.854 219.8H56.1455C52.9006 219.8 50.2002 216.506 50.2002 212.348V51.6523C50.2002 47.4936 52.9006 44.2004 56.1455 44.2002Z"
          fill="white"
          stroke="#495A74"
          strokeWidth={0.4}
        />
        <rect x={62} y={155} width={94} height={21} rx={3} fill="#0B66E4" />
        <rect x={62} y={127} width={94} height={12} rx={2} fill="#DFEAFB" />
        <rect x={62} y={122} width={24} height={3} rx={1} fill="#DFEAFB" />
        <rect x={62} y={94} width={94} height={12} rx={2} fill="#DFEAFB" />
        <rect x={62} y={88} width={24} height={3} rx={1} fill="#DFEAFB" />
        <path
          d="M56 203V70.9203C56 67.6506 58.6506 65 61.9203 65H156.08C159.349 65 162 67.6506 162 70.9203V203"
          stroke="#495A74"
          strokeWidth={0.338301}
        />
      </g>
    </g>
    <path
      d="M120.233 55.0403H100.305C99.0353 55.0403 98.0059 56.1763 98.0059 57.5775C98.0059 58.9788 99.0353 60.1148 100.305 60.1148H120.233C121.503 60.1148 122.533 58.9788 122.533 57.5775C122.533 56.1763 121.503 55.0403 120.233 55.0403Z"
      fill="#495A74"
    />
    <rect x={139} y={37} width={45} height={45} rx={22.5} fill="#00CD58" />
    <path
      d="M154.365 59.9061L158.492 64.022L167.536 54.9781"
      stroke="white"
      strokeWidth={1.64634}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_539_1038"
        x={41.28}
        y={30.92}
        width={135.44}
        height={191.44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={-4.36} />
        <feGaussianBlur stdDeviation={4.36} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_539_1038"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_539_1038"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_539_1038"
        x1={109}
        y1={0}
        x2={109}
        y2={218}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E3ECFA" />
        <stop offset={1} stopColor="#DAE7FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_539_1038"
        x1={109}
        y1={0}
        x2={109}
        y2={218}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E3EEFA" />
        <stop offset={1} stopColor="#DAECFF" />
      </linearGradient>
    </defs>
  </svg>
);

